import { displayAmount } from "src/utils/displayAmount"

export const calculateMultiplier = (betAmount: number, potentialPayout: number): number => {
  if (betAmount === 0) return 0

  const multiplier = potentialPayout / betAmount

  return parseFloat(displayAmount(multiplier))
}
